/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import { Label, LabelFromJSON, LabelFromJSONTyped, LabelToJSON } from './Label'

/**
 *
 * @export
 * @interface CreateLabelResponseData
 */
export interface CreateLabelResponseData {
  /**
   *
   * @type {Label}
   * @memberof CreateLabelResponseData
   */
  label?: Label
}

export function CreateLabelResponseDataFromJSON(json: any): CreateLabelResponseData {
  return CreateLabelResponseDataFromJSONTyped(json, false)
}

export function CreateLabelResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLabelResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    label: !exists(json, 'label') ? undefined : LabelFromJSON(json['label'])
  }
}

export function CreateLabelResponseDataToJSON(value?: CreateLabelResponseData | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    label: LabelToJSON(value.label)
  }
}
